/* 
  项目材料信息管理
*/
import request from "@/utils/request";
let baseUrl1 = window.config.baseUrl1  // 梁江辉接口地址1
let baseUrl2 = window.config.baseUrl2  // 飞泉接口地址online

//获取项目材料信息管理页面参数
export function getParam() {
  return request({
    url: "/baseinfo/teacherinfo/getParam",
    method: "get"
  });
}

//获取项目材料信息管理页面参数
export function getTeacherInfoByCardId(cardId) {
  return request({
    url: "/baseinfo/teacherinfo/getTeacherInfoByCard?teacherCard=" + cardId,
    method: "get"
  });
}

//获取项目材料信息管理分页列表
export function getProjectMaterialInfo(params) {
  return request({
    url: "/baseinfo/projectMaterial/getProjectMaterialInfo",
    method: "get",
    params
  });
}

//保存或编辑项目材料信息
export function saveOrUpdate(data) {
  return request({
    url: "/baseinfo/teacherinfo/editBaseInfo",
    method: "post",
    data
  });
}

//编辑项目材料报名信息
export function saveOrUpdateEnrollInfo(data) {
  return request({
    url: "/baseinfo/teacherinfo/editSignInfo",
    method: "post",
    data
  });
}
//打印项目材料信息
export function downloadCl(data) {
  return request({
    url: "/baseinfo/projectMaterial/downloadCertificate",
    method: "post",
    responseType: 'blob',
    data
  });
}

//添加项目材料信息
export function addProjectMaterialInfo(data) {
  return request({
    url: "/baseinfo/projectMaterial/add",
    method: "post",
    data
  });
}

//删除项目材料信息
export function deleteTeacherInfo(data) {
  return request({
    url: "/baseinfo/projectMaterial/deleteProjectMaterialInfo",
    method: "post",
    data
  });
}

//标记是否有效
export function markValid(data) {
  return request({
    url: "/baseinfo/teacherinfo/markValid",
    method: "post",
    data
  });
}

//推荐或取消推荐
export function setRecommend(data) {
  return request({
    url: "/baseinfo/teacherinfo/setRecommend",
    method: "post",
    data
  });
}

//发送短信息
export function sendMessageTeacherInfoManage(data) {
  return request({
    url: "/baseinfo/teacherinfo/sendMessage",
    method: "post",
    data
  });
}

//发送通知
export function sendNoticeTeacherInfoManage(data) {
  return request({
    url: "/baseinfo/teacherinfo/sendInform",
    method: "post",
    data
  });
}

//项目材料总人数/有效人数
export function validTeacherNum(projectId) {
  let url = "/baseinfo/teacherinfo/validTeacherNum";
  if(projectId){
    url += `?projectId=${projectId}`
  }
  return request({
    url,
    method: "get"
  });
}

//查看项目材料详情信息
export function getTeacherDetailInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/getTeacherDetailInfo",
    method: "get",
    params
  });
}

// 获取短信项目材料名单
export function getMsgTeacher(params: Object) {
  return request({
    url: "/baseinfo/teacherinfo/getMsgTeacher",
    method: "get",
    params
  });
}